<template>
  <div class="txtDetails">
    <dyn-slot v-if="$slots[`txtDetails${tariffId}`]" :slot-data="tariff">
      <slot :name="`txtDetails${tariffId}`"></slot>
    </dyn-slot>
    <dyn-slot v-else-if="extraType && $slots[`txtDetails${extraType}`]"
      :slot-data="tariff">
      <slot :name="`txtDetails${tariff.tariffExtra.type}`"></slot>
    </dyn-slot>
    <dyn-slot v-else :slot-data="tariff"><slot name="txtDetails"></slot></dyn-slot>
  </div>
</template>
<script>

import slotProxy from '@/mixins/slotProxy'
import tariffOptionHelper from '@/mixins/tariffOptionHelper'

export default {
  name: 'TariffOverview',
  mixins: [
    slotProxy(),
    tariffOptionHelper
  ],
  computed: {
    extraType: function () {
      return this.tariff?.tariffExtra?.type
    },
    tariffId: function () {
      return (this.tariff.tariffId === '165' && this.isCCS92060Booked)
        ? this.tariff.tariffId + '777' // es wird ein anderer Modaltext angezeigt, wenn die Tarifoption Double Data L CCS_92060 gebucht ist
        : this.tariff.tariffId
    },
    isCCS92060Booked: function () {
      return this.isTariffOptionBooked('CCS_92060')
    }
  },
  props: {
    tariff: {
      type: Object,
      default: null
    }
  }
}
</script>
